import { Injectable } from "@angular/core";
import { Device } from '@capacitor/device';
import { TranslateService } from "@ngx-translate/core";
import { IDatePlace } from "src/app/models/location.model";
import { TourneeModel } from "src/app/models/tournee.model";
import { UtilsService } from "../utils/utils.service";

@Injectable({
  providedIn: "root"
})
export class DateService {
  local = "fr-fr";

  

  constructor(private translateService: TranslateService, private utils:UtilsService) {
    Device.getLanguageCode().then(result=> {
      this.local = result.value;
    });
  }

  public formatToLongDate(inDate: string): string {
    const date = new Date(inDate);
    return date.toLocaleString(this.local, { weekday: "long", year: "numeric", month: "long", day: "numeric" });
  }

  formatToShortDate(inDate: string, upperCase?:boolean): string {
    const date = new Date(inDate);
    let dateStr = date.toLocaleString(this.local, { weekday: "long", month: "long", day: "numeric" });
    if(upperCase){
      dateStr = dateStr.charAt(0).toUpperCase() + dateStr.slice(1);
    }
    return dateStr;
  }

  getDatePlaceLabel(datePlace: IDatePlace){
    let label = '';
    const date = new Date(datePlace.date);
    label += date.toLocaleString(this.local, { weekday: "long", month: "long", day: "numeric" });
    label += " " + this.translateService.instant('common.between') +' ' + datePlace.fromTimeHour +' ' + this.translateService.instant('common.and') +' ' + datePlace.toTimeHour; 
    if(datePlace.geocoding){
      label += " " + this.translateService.instant('common.in') +' ' + (datePlace.geocoding.name || (datePlace.geocoding.address.city + ' ' + datePlace.geocoding.address.street))
    }
    return label
  }

  formatToMonthYearDate(inDate: string, upperCase?:boolean): string {
    const date = new Date(inDate);
    let dateStr = date.toLocaleString(this.local, { month: "long", year:"numeric" });
    if(upperCase){
      dateStr = dateStr.charAt(0).toUpperCase() + dateStr.slice(1);
    }
    return dateStr;
  }
  shiftDateplaces(datePlaces:IDatePlace[], dateRef:string, increment?:number): IDatePlace[]{
    let datePlacesShifted = datePlaces.sort(this.sortByDates);
    const shift = this.dateDiffInDays(datePlacesShifted[0].date, dateRef)+(increment||0);
    for(const item of datePlacesShifted){
      item.date = this.addDays(item.date, shift);
    }
    return datePlacesShifted;
  }

  generateDatePlaceKey(item:IDatePlace){
    let key = item.date.substring(0,10);
    if(item.fromTimeHour){
      key+='_'+item.fromTimeHour+'_'+item.toTimeHour;
    }
    if(item.geocoding){
      key += '_'+ item.geocoding.locationID;
    }
    return key;
  }

  formatDetailsToShortDate(details: any, upperCase?:boolean, deliveryType?:string, index?:number, dayOnly?:boolean, long?:boolean): string {
    if(!details){ return this.translateService.instant("common.Unknown.female")}
    const date = new Date((index>=0 && details.datesPlaces && details.datesPlaces[index])?details.datesPlaces[index].date:details.date);
    let dateStr = '';
    if(index>=0 && !long){
      dateStr = date.toLocaleString(this.local, { weekday: "short", month: "long", day: "numeric" });
      dateStr = dateStr.split(' ')[0];
    }
    else{
      dateStr = date.toLocaleString(this.local, { weekday: "long", month: "long", day: "numeric" });
    }
    if(upperCase){
      dateStr = dateStr.charAt(0).toUpperCase() + dateStr.slice(1);
    }
    if (deliveryType !== 'tournee' && ((details.toTimeHour && details.fromTimeHour) || (index>=0 && details.datesPlaces && details.datesPlaces[index] && details.datesPlaces[index].fromTimeHour && details.datesPlaces[index].toTimeHour))) {
      let fromTimeHour = ((index>=0 && details.datesPlaces && details.datesPlaces[index])?details.datesPlaces[index].fromTimeHour:details.fromTimeHour).replace(':',this.translateService.instant('date.h'));
      if(fromTimeHour.charAt(0) ==='0'){
        fromTimeHour = fromTimeHour.slice(1);
      }
      let toTimeHour = ((index>=0 && details.datesPlaces && details.datesPlaces[index])?details.datesPlaces[index].toTimeHour:details.toTimeHour).replace(':',this.translateService.instant('date.h'));
      if(toTimeHour.charAt(0) ==='0'){
        toTimeHour = toTimeHour.slice(1);
      }
      fromTimeHour = fromTimeHour.replace('00','');
      toTimeHour = toTimeHour.replace('00','');
      dateStr += ' ' + fromTimeHour + ' - ' + toTimeHour;
    }
    else if(details.fromTimeHour && !details.toTimeHour) {
      dateStr += ' ' + ((index>=0 && details.datesPlaces && details.datesPlaces[index])?details.datesPlaces[index].fromTimeHour:details.fromTimeHour);
    }
    else if(details.moment){
      dateStr += ' ' + this.translateService.instant("tournee.moments.NoCap."+ ((index>=0 && details.datesPlaces && details.datesPlaces[index])?details.datesPlaces[index].moment:details.moment));
    }
    return dateStr;
  }

  formatDatePlaceToDateShort(datePlace: IDatePlace, upperCase?:boolean): string {
    const date = new Date(datePlace.date);
    let dateStr = date.toLocaleString(this.local, { weekday: "short", month: "short", day: "numeric" });

    let fromTimeHour = datePlace.fromTimeHour.replace(':',this.translateService.instant('date.h'));
    if(fromTimeHour.charAt(0) ==='0'){
      fromTimeHour = fromTimeHour.slice(1);
    }
    let toTimeHour = datePlace.toTimeHour.replace(':',this.translateService.instant('date.h'));
    if(toTimeHour.charAt(0) ==='0'){
      toTimeHour = toTimeHour.slice(1);
    }
    fromTimeHour = fromTimeHour.replace('00','');
    toTimeHour = toTimeHour.replace('00','');
    dateStr += ' ' + fromTimeHour + ' - ' + toTimeHour;

    if(upperCase){
      dateStr = dateStr.charAt(0).toUpperCase() + dateStr.slice(1);
    }
    return dateStr;
  }

  formatTimeHours(datePlace:IDatePlace):string{
    let dateStr = '';
    let fromTimeHour = datePlace.fromTimeHour.replace(':',this.translateService.instant('date.h'));
    if(fromTimeHour.charAt(0) ==='0'){
      fromTimeHour = fromTimeHour.slice(1);
    }
    let toTimeHour = datePlace.toTimeHour.replace(':',this.translateService.instant('date.h'));
    if(toTimeHour.charAt(0) ==='0'){
      toTimeHour = toTimeHour.slice(1);
    }
    fromTimeHour = fromTimeHour.replace('00','');
    toTimeHour = toTimeHour.replace('00','');
    dateStr += ' ' + fromTimeHour + ' - ' + toTimeHour;
    return dateStr
  }

  resumeDatesPlaces(datesPlaces: IDatePlace[], upperCase?:boolean): string {
    if(datesPlaces.length == 0 ){ return this.translateService.instant("common.Unknown.female")}
    if(datesPlaces.length == 1 ){ 
      return new Date(datesPlaces[0].date).toLocaleString(this.local, { weekday: "short", month: "long", day: "numeric" })
        + this.formatTimeHours(datesPlaces[0]);
    }
    else{
      const days:string[] = [];
      for(const datePlace of datesPlaces){
        days.push(new Date(datePlace.date).toLocaleString(this.local, { weekday: "short"}));
      }
      const uniqueDays =  [...new Set(days)];
      if(uniqueDays.length ==1) return new Date(datesPlaces[0].date).toLocaleString(this.local, { weekday: "short", month: "long", day: "numeric" })
      return this.utils.arrayToList(uniqueDays);
    }
  }

  formatDatePlace(datePlace: any, upperCase?:boolean, long?:boolean, place?: boolean): string {
    let dateStr = '';
    if(!long){
      dateStr = new Date(datePlace.date).toLocaleString(this.local, { weekday: "short", month: "short", day: "numeric" });
    }
    else{
      dateStr = new Date(datePlace.date).toLocaleString(this.local, { weekday: "long", month: "long", day: "numeric" });
    }
    if(upperCase){
      dateStr = dateStr.charAt(0).toUpperCase() + dateStr.slice(1);
    }
    if (datePlace.toTimeHour && datePlace.fromTimeHour){
      let fromTimeHour = datePlace.fromTimeHour.replace(':',this.translateService.instant('date.h'));
      if(fromTimeHour.charAt(0) ==='0'){
        fromTimeHour = fromTimeHour.slice(1);
      }
      let toTimeHour = datePlace.toTimeHour.replace(':',this.translateService.instant('date.h'));
      if(toTimeHour.charAt(0) ==='0'){
        toTimeHour = toTimeHour.slice(1);
      }
      fromTimeHour = fromTimeHour.replace('00','');
      toTimeHour = toTimeHour.replace('00','');
      dateStr += ' ' + (long? this.translateService.instant('tournee.moments.NoCap.From') :'') + ' ' + fromTimeHour 
      + ' ' + (long? this.translateService.instant('tournee.moments.NoCap.To') :'-') + ' ' + toTimeHour;
    }
    dateStr += place?(' ' + (datePlace.name || datePlace.geocoding.address.city)):'';
    return dateStr;
  }

  reduceTimeString(time:string){
    if(time.charAt(0) ==='0'){
      time = time.slice(1);
    }
    time = time.replace(':00',':');
    time = time.replace(':',this.translateService.instant('date.h'));
    return time;
  }

  isDifferentMonth(a:string, b:string){
    console.log('isDifferentMonth',a.slice(0,7),b.slice(0,7));
    return a.slice(0,7)!==b.slice(0,7)
  }


  formatToShortDateTime(inDate: string, upperCase?:boolean): string {
    const date = new Date(inDate);
    let dateStr = date.toLocaleString(this.local, { weekday: "long", month: "long", day: "numeric", hour:"2-digit",minute:"2-digit" });
    if(upperCase){
      dateStr = dateStr.charAt(0).toUpperCase() + dateStr.slice(1);
    }
    return dateStr;
  }

  formatHour(inDate: string): string {
    if(inDate.match('^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$')){
      // console.log('match regex')
      return inDate;
    }
    else{
      const date = new Date(inDate);
      return date.toLocaleTimeString("fr-fr", { hour: "2-digit", minute: "2-digit" });      
    }
  }

  formatToShortMonthAbsDate(inDate: string): string {
    const date = new Date(inDate);
    return date.toLocaleString(this.local, { weekday: "long", month: "short", day: "numeric" });
  }

  
  formatFullDate(datePlace: IDatePlace, recurrence: string, frequency: number, upperCase?: boolean): string {
    const date = new Date(datePlace.date);
    let dateStr = "";
    if(recurrence=="weekly"){
      dateStr +=this.translateService.instant("common.EveryDay")+" ";
      dateStr += frequency > 1 ? frequency : '';
      dateStr += this.getDayName(date) + "s";
    }
    else{
      dateStr += this.formatToShortMonthAbsDate(datePlace.date);
    }

    dateStr +=
      " " +
      this.translateService.instant("common.between") +
      " " +
      this.reduceTimeString(datePlace.fromTimeHour) +
      " " +
      this.translateService.instant("common.and") +
      " " +
      this.reduceTimeString(datePlace.toTimeHour);
    if(upperCase) dateStr = dateStr.charAt(0).toUpperCase() + dateStr.slice(1)
    else dateStr = dateStr.toLowerCase();
    return dateStr;
  }

  firstUpper(input:string):string{
    return input.charAt(0).toUpperCase() + input.slice(1)
  }

  formatDateWithMoment(inDate: string, moment: string, recurrence: string): string {
    const date = new Date(inDate);
    let dateStr = "";
    if(recurrence=="weekly"){
      dateStr +=this.translateService.instant("common.EveryDay")+" ";
      dateStr += this.getDayName(date) + "s";
    }
    else{
      dateStr += this.formatToShortMonthAbsDate(inDate);
    }

    dateStr += " " + this.translateService.instant("tournee.moments.NoCap."+moment)
    return dateStr;
  }

  substractDays(dateStr:string,numberOfDays:number):string{
    // console.log(dateStr)
    if(dateStr){
      const date = new Date(this.setTimeToZero(dateStr));
      date.setDate(date.getDate()-(numberOfDays-1));
      let dateOuput = this.firstUpper(date.toLocaleString(this.local, { weekday: "short" })) + ' ' + date.getDate();
      return dateOuput      
    }
    else{
      return
    }
  }
  addDays(dateStr:string,numberOfDays:number):string{
    const date = new Date(this.setTimeToZero(dateStr));
    date.setDate(date.getDate()+(numberOfDays||0));
    let dateOuput = date.toISOString();
    return dateOuput
  }


  formatDate(inDate: string, fromTime: string, toTime: string): string {
    const date = new Date(inDate);
    const day = this.getDayName(date);
    let dateStr = day.charAt(0).toUpperCase() + day.slice(1);
    dateStr +=
      " " +
      this.translateService.instant("common.between") +
      " " +
      fromTime +
      " " +
      this.translateService.instant("common.and") +
      " " +
      toTime;
    return dateStr;
  }

  getDayName = function (inDate: Date): string {
    const date = new Date(inDate);
    return date.toLocaleString(this.local, { weekday: "long" });
  };

  getWeek = function (inDate: Date) {
    const date = new Date(inDate.getTime());
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
    // January 4 is always in week 1.
    const week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7);
  };

  setTimeToZero(dateIn:string):string{
    return dateIn.slice(0,10) + 'T00:00:00.000Z';
  }

  setTime(dateIn:string, time:string):string{
    return dateIn.slice(0,11) + time + ':00.000Z';
  }

  cleanTime(time:string){
    const timeArr = time.split(":");
    return timeArr[0].slice(-2) +':'+ timeArr[1].slice(0,2);
  }

  cleanDatePlace(datesPlaces:IDatePlace[]):IDatePlace[] {
    datesPlaces.forEach(item=>{
      item.toTimeHour = this.cleanTime(item.toTimeHour);
      item.toTimeHour = this.cleanTime(item.toTimeHour);
      item.date = this.setTimeToZero(item.date);
    })
    datesPlaces = datesPlaces.sort(this.sortByDates);
    return datesPlaces
  }

  sortByDates(a:IDatePlace,b:IDatePlace){
    if(a.date < b.date){
      return -1
    }
    else if(a.date > b.date){
      return 1
    }
    else if(a.fromTimeHour > b.fromTimeHour){
        return 1
    }
    else{
      return -1
    }
  }

  public toFirstUppercase(str:string):string{
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  public getWeekString(inDate: string): any {
    if(!inDate){
      return { order: 7, name: this.translateService.instant("date.Unknown") }
    }
    const date = new Date(inDate);
    // const thisWeek = this.getWeek(new Date());
    // const inDateWeek = this.getWeek(date);
    const now = new Date()
    now.setDate(now.getDate()-now.getDay()+1);
    const timeDifference = Math.floor(((now.getTime() - date.getTime())/(1000*60*60*24)));
    const weekDifference =  timeDifference>0?Math.ceil(timeDifference / 7):Math.ceil(timeDifference / 7);
    // console.log('getWeekString',inDate,date, now, timeDifference, weekDifference);

    if (weekDifference == 0) {
      return { order: 1, name: this.translateService.instant("date.ThisWeek") };
    } else if (weekDifference >=1 ) {
      return { order: 6, name: this.translateService.instant("date.Earlier") };
    } else if (weekDifference == 1) {
      return { order: 5, name: this.translateService.instant("date.LastWeek") };
    } else if (weekDifference == -1) {
      return { order: 2, name: this.translateService.instant("date.NextWeek") };
    } else if (weekDifference == -2) {
      return { order: 3, name: this.translateService.instant("date.WeekAfter") };
    } else {
      return { order: 4, name: this.translateService.instant("date.Later") };
    }
  }

  public getDatesOpeningStatus(tournee:TourneeModel, checkOpen:boolean){
    let datesArray = [];
    if(tournee.details.datesPlaces && tournee.details.datesPlaces.length>0){
      datesArray = tournee.details.datesPlaces;
    }
    const dates = datesArray
          .map(date => <any>{
            status:false,
            geocoding: date.geocoding || tournee.details.geocoding,
            disabled: checkOpen?!this.checkIfOpen(tournee,date):false,
            openStatus: this.checkIfOpen(tournee,date),
            key:this.generateDatePlaceKey(date),
            icon:'calendar-clear',
            label:this.formatDetailsToShortDate(date,true,tournee.details.deliveryType),
            ...date});
    return dates.sort(this.sortByDates);
  }

  public unSelectDates(datesIn:IDatePlace[]): IDatePlace[]{
    datesIn.forEach(date => {
      date.selected=false
    })
    return datesIn;
  }

  public checkIfOpen(tournee:TourneeModel,date:IDatePlace){
    const todayStr = this.cleanTime(new Date().toISOString());
    const firstDate = this.getFirstDateStr(tournee);
    const openingDate = this.calculateOpeningDateTime(tournee, {date:firstDate});
    const closingDate = this.calculateClosingDateTime(tournee, date)
    return (tournee.status ==='open' || todayStr >= openingDate) && todayStr <= closingDate;
  }

  public dateDiffInDays(date1:string, date2:string):number{
    const dateBefore = new Date(this.setTimeToZero(date1)).getTime();
    const dateAfter = new Date(this.setTimeToZero(date2)).getTime();
    const diff = Math.floor((Math.abs(dateAfter - dateBefore))/(1000*60*60*24));
    return diff
  }

  public getLastDateStr(sale:any):string{
    return (sale.details.datesPlaces && sale.details.datesPlaces.length>0)?sale.details.datesPlaces[sale.details.datesPlaces.length-1].date: sale.details.date;
  }

  public getFirstDateStr(sale:any):string{
    return (sale.details.datesPlaces && sale.details.datesPlaces.length>0)?sale.details.datesPlaces[0].date: sale.details.date;
  }
  public getFirstDateTimeStr(sale:any):string{
    return (sale.details.datesPlaces && sale.details.datesPlaces.length>0)?sale.details.datesPlaces[0].fromTimeHour: sale.details.fromTimeHour;
  }

  public calculateOpeningDateTime(tournee:TourneeModel, date:IDatePlace){
    return this.substractDays(this.setTimeToZero(date.date),tournee.details.opening>=0?(tournee.details.opening-1):7);
  }

  public calculateClosingDateTime(tournee:TourneeModel, date:IDatePlace){
      const lastDate = this.getLastDateStr(tournee);
      if(tournee.details.closing === 0){
        return this.setTime(date.date,date.fromTimeHour);
      }
      else{
        return this.substractDays(this.setTimeToZero(date.date),tournee.details.closing>0?(tournee.details.closing-1):1);  
      }
  }

  public calculateNextDate(sale:TourneeModel):string{
    const firstDay = this.getFirstDateStr(sale);
    const firstTime = this.getFirstDateTimeStr(sale);
    const day = new Date(firstDay).getDay();
    const today = new Date();
    const todayDay = today.getDay();
    let increment = 0;
    if (day == todayDay){
      increment = 7;
    }
    else if(day < todayDay){
      increment = (6-todayDay) + day + 1;
    }
    else {
      increment = (day - todayDay);
    }
    console.log(day, todayDay, increment);
    return this.setTime(this.addDays(today.toISOString(),increment), firstTime);
  }

}
